import React, { useState, useEffect } from "react";
import { StandardView } from "wm-standard-crud";
import BasePage from "components/basePage/BasePage";
import { getUrlGroupDetails } from "services/requests";
import { showToast } from "services/helper";
import "./UrlGroupDetails.scss";
import { useParams } from "react-router-dom";

function UrlGroupDetails(props) {
  const { groupId } = useParams();
  //STATE
  const [descriptor, setDescriptor] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getUrlGroupDetails(groupId)
      .then((data) => setDescriptor(data))
      .catch(() => {
        showToast(
          "Parece que não foi possível buscar as informações, tente novamente mais tarde.",
          "error"
        );
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <BasePage loading={loading}>
      <StandardView descriptor={descriptor} />
    </BasePage>
  );
}

export default UrlGroupDetails;
